export const JSONtoURL =  (data) => data && Object.keys(data).filter(k => data[k] !== undefined).map(function(k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
}).join('&')

export function convertToSlug(Text)
{
    return Text
        .toLowerCase()
        .replace(/ /g,'-')
        .replace(/[^\w-]+/g,'')
        ;
}

export const mobileW = 768
export const tabletW = 1024

const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

export function isURL(str) {
    return !!pattern.test(str);
}

export const getPubFromURL = (str) => {
    const vk_url = "https://vk.com/"
    const ind = str.indexOf(vk_url)
    if(ind >= 0){
        const path = str.slice(ind + vk_url.length)
        if(path.indexOf("club") == 0){
            return -path.slice(4)
        }else if(path.indexOf("public") == 0){
            return -path.slice(6)
        }else{
            return path
        }
    }else{
        return false        
    }
}

export function isOverflown(element) {
    return element && element.scrollWidth > element.clientWidth;
}

export function replaceURLWithHTMLLinks(text) {
    var re = /(\(.*?)?(\b|href='|")((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig;
    // console.log(text);
    return text.replace(re, function(match, lParens, href ,url) {
        // console.log(match, lParens, href, url);
        if (href) {
            return match
        } else {
            var rParens = '';
            lParens = lParens || '';
            var lParenCounter = /\(/g;
            while (lParenCounter.exec(lParens)) {
                var m;
                if (m = /(.*)(\.\).*)/.exec(url) ||
                        /(.*)(\).*)/.exec(url)) {
                    url = m[1];
                    rParens = m[2] + rParens;
                }
            }
            return lParens + "<a href='" + url + "'>" + url + "</a>" + rParens;            
        }
    });
}

export const formatText = (text) => {
    return replaceURLWithHTMLLinks(text).replace(/\n/g, "<br/>")
}

export function orderItems(arrayObjects, arrayIds) {
        if(!arrayIds.length) return arrayObjects
        const arrayItems = [];
        const arrayItemsAbsentIds = [];
        for (let i = 0; i < arrayObjects.length; i++) {
            if (arrayIds.indexOf(arrayObjects[i]._id) == -1) {
                arrayItemsAbsentIds.push(arrayObjects[i])
            } else {
                arrayItems[arrayIds.indexOf(arrayObjects[i]._id)] = arrayObjects[i]  
            }
        }
        return arrayItems.concat(arrayItemsAbsentIds)
}

export function searchNotices(notices, item, searchingNotices) {
    notices.forEach(notice => {
        if (item && item.name && notice.body) {            
            const regexp= new RegExp(`(\\W|^)${item.name.toLocaleLowerCase()}(\\W|$)`,'gm')
            const result= notice.body.toLocaleLowerCase().match(regexp)
            if (result !== null) {
                searchingNotices.push(notice)
            } 
        }
    })
}

export function relevantNotices(feeds, task) {
    const allNotices = feeds.map(feed => feed.notices).flat()  
    const relevantedNotices = []
    searchNotices(allNotices, task, relevantedNotices)
    task.subs.forEach(sub => {
        searchNotices(allNotices, sub, relevantedNotices)
    })
    return [...new Map(relevantedNotices.map(notice => [notice._id, notice])).values()];
}

export function elemInViewport(el){
    const y = el.getBoundingClientRect().y
    return y && y < (window.innerHeight + 200)
}

export function imagesOfItems(item) {
    const regexpHref = new RegExp('href="([^"]*)"', 'g') 
    const links = item.body.match(regexpHref)
    if (links) {
      const regexpLinks = new RegExp('http(?::\\/\\/|s:\\/\\/).*?\\.(?:gif|jpg|jpeg|png)', 'i')
      const filteredLinks = [...links.map(el => el.slice(5).split('"').join(''))].filter(el =>  el.match(regexpLinks))
      return filteredLinks.map(el => el.replace(new RegExp("amp;", 'g'), ""))
    } else return []
  } 

export function searchEmail(email) {
    const regExp = /.+@.+\..+/i
    return regExp.test(email)
}

export function searchPassword(password) {
    const regExp = /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{8,}$/gm
    return regExp.test(password)
}